module.exports = __webpack_public_path__ + "static/media/gptrac_reversed.140a10ad.svg";